import React from 'react'

const index = ({ onClick, isOpen, dataRef, unread }) => {
    return (
        <zui-headerbar-notification-button
            slot="iconButtons"
            has-notifications
            onClick={onClick}
            data-ref={dataRef}
            emphasis={isOpen ? 'selected' : 'default'}
        >
            <zui-icon-alerts-alarm-on slot="icon" data-ref={dataRef}></zui-icon-alerts-alarm-on>
            {unread && (
                <zui-state-dot slot="stateDot" state="error" data-ref={dataRef}></zui-state-dot>
            )}
        </zui-headerbar-notification-button>
    )
}

export default index
